class DrawerBase {
  static bind(container) {
    if (!container) return;

    const overlay = container.querySelector(".cart-drawer-overlay, .drawer-overlay");
    const closeButton = container.querySelectorAll(".cart-drawer__close, [data-drawer-close]");

    if (overlay) {
      overlay.addEventListener("click", () => DrawerBase.close(container));
    }

    if (closeButton) {
      closeButton.forEach((button) => {
        button.addEventListener("click", () => DrawerBase.close(container));
      });
    }

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        if (container.classList.contains("is-active")) {
          DrawerBase.close(container);
        }
      }
    });
  }

  static open(container) {
    if (!container) return;
    container.classList.add("is-active");
    document.body.style.overflow = "hidden";
  }

  static close(container) {
    if (!container) return;
    container.classList.remove("is-active");
    document.body.style.overflow = "";
  }
}

// Expose globally
if (typeof window !== "undefined") {
  window.DrawerBase = DrawerBase;
}

// Export for tests if needed
if (typeof module !== "undefined" && module.exports) {
  module.exports = DrawerBase;
}
